export default "__VITE_ASSET__9f245a86__"